import { useId } from 'react'
import { brandMark } from '@lunary/ui-tokens'

type Props = { size?: number; title?: string; className?: string }

export const LUNAR_COIN_SMALL_MAX = 24

export function LunarCoin({ size = 32, title, className }: Props) {
  const gradient = `lunar-coin-${useId().replace(/:/g, '')}`
  const small = size <= LUNAR_COIN_SMALL_MAX
  const mark = small ? 'translate(34 32) scale(0.6) translate(-54 -50)' : 'translate(32 32) scale(0.5) translate(-62 -50)'
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      className={className}
      role={title ? 'img' : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
    >
      <defs>
        <linearGradient id={gradient} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="var(--coin-hi)" />
          <stop offset="0.5" stopColor="var(--coin-mid)" />
          <stop offset="1" stopColor="var(--coin-lo)" />
        </linearGradient>
      </defs>
      <circle cx="32" cy="32" r="30" fill={`url(#${gradient})`} />
      <circle cx="32" cy="32" r="30" fill="none" stroke="var(--coin-lo)" strokeWidth={small ? 3 : 2} />
      {!small && <circle cx="32" cy="32" r="25.5" fill="none" stroke="var(--coin-ink)" strokeOpacity="0.28" />}
      <g fill="var(--coin-ink)" transform={mark}>
        <path d={brandMark.letter} />
        <path d={brandMark.moon} />
        {!small && <path d={brandMark.sparkLarge} />}
        {!small && <path d={brandMark.sparkSmall} />}
      </g>
    </svg>
  )
}
